// Helper to safely attempt audio playback and surface async errors (play() returns a Promise)
export const playAudio = (audio: HTMLAudioElement) => {
    try {
        const playResult = audio.play();
        if (playResult && typeof (playResult as any).catch === 'function') {
            (playResult as Promise<void>).catch((err) => {
                // Ignore abort errors (can occur if playback is interrupted) but log others
                if (!err || err.name !== 'AbortError') {
                    console.warn('Error playing sound', err);
                }
            });
        }
    } catch (err) {
        // This catch only handles synchronous exceptions (rare) – async errors handled above
        console.warn('Synchronous error initiating audio playback', err);
    }
};